<template>
  <v-container grid-list-xl filterColumns>
    <center><img class="imgLoader" style="padding-top: 3% !important;" src="../../shared/assets/images/3dloader.gif" v-if="loaded == false" /></center>
    <v-layout row wrap v-if="loaded == true">
      <v-flex lg12 class="">
        <p v-show="columnsLoading== true">Recalculating Columns<br /><small>Please wait...</small></p>
        <v-data-table v-show="columnsLoading== false" ref="sortableTable" :items="row" hide-actions class="elevation-1 columnTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
          <template slot="items" slot-scope="props">
            <tr class="sortableRow" id="rows" v-for="(s, index) in objQuoteSettings" v-if="fncCheckColumn(s)">
              <td width="5%" class="px-1">
                <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
              </td>
              <td width="15%"><v-switch @change="fncReorderQuoteColumnsNoSort" v-model="s.checked"></v-switch></td>
              <td width="40%" v-if="!fncCheckNumber(s.id)" v-html="fncGetLabel(s.label)"></td>
              <td width="80%" v-if="fncCheckNumber(s.id)">
                <v-select label="Select Column Role" @input="fncSetId(s)" style="width:87%;display:block;float:left;margin-top: 0px !important;" v-model="s.id" item-value="id" :items="repRoles" item-text="name" solo outline autocomplete></v-select>
              </td>
<!--              <td width="40%" class="text-xs-right"><v-select @input="fncReorderQuoteColumnsNoSort" v-model="s.width" item-value="id" :items="columnWidths" autocomplete solo></v-select></td>-->
            </tr>
          </template>
        </v-data-table>
        <v-btn @click="fndAddRoleColumn">Add Role Column</v-btn>
      </v-flex>
      <div class="pl-4 pr-1 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
          <!--<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
          <v-btn color="success" class="text-xs-right" @click.stop="fncSaveSettings()">Update</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  //import draggable from 'vuedraggable'
  import Sortable from 'sortablejs';
  import DatePicker from 'vue2-datepicker'
  export default {
    name: 'Settings',
    data() {
      return {
        //objQuoteSettings: this.$store.getters.objQuoteSettings,
        row: ['order'],
        columnWidths: [
          { id: 'auto', text: 'Auto Fit' },
          { id: '100px', text: '100px' },
          { id: '200px', text: '200px' },
          { id: '300px', text: '300px' },
          { id: '400px', text: '400px' },
          { id: '500px', text: '500px' },
        ],
        loaded: true,
        repRoles: []
      };
    },
    methods: {
      fncGetLabel( label ) {
        if( label == 'Responsible Rep') {
          return 'Users Linked to Quote';
        } else {
          return label;
        }
        return 'Veld Skool';
      },
      fncSetId(index) {

        var setIndex = ( index.order ) - 1;
        if( ( index.order + 1 ) == this.objQuoteSettings.length ) { console.log('LAST ITEM'); setIndex = index.order; }

        for( var r in this.userRoles ) {
          if( this.userRoles[r].id == index.id ) {
            this.objQuoteSettings[setIndex].label = this.userRoles[r].name;
          }
        }
        this.fncCustomReorder();
      },
      fncCustomReorder() {
        var toSave = [];
        var n = 1;
        for( var c in this.objQuoteSettings ){
          if( this.objQuoteSettings[c].checked == true ) {
            var subSave = this.objQuoteSettings[c];
            subSave.order = n;

            toSave.push( subSave );

            n++;
          }
        }
        for( var c in this.objQuoteSettings ){
          if( this.objQuoteSettings[c].checked != true ) {
            var subSave = this.objQuoteSettings[c];
            subSave.order = n;

            toSave.push( subSave );

            n++;
          }
        }
        //this.$store.commit('setQuoteSettings', toSave);
        //setTimeout(function(){
          this.fncReorderQuoteColumnsNoSort( toSave );
        //}, 100)
      },
      fncCheckNumber(value) {
        if (isNaN(value) ) {
          return false;
        } else {
          return true;
        }
      },
      fndAddRoleColumn(){
        var toPush = { checked: true, id: '', label: '', order: this.objQuoteSettings.length, width: 'auto' };
        this.objQuoteSettings.push( toPush );
      },
      fncCheckColumn( column ) {
        /*if( this.objAuthorize.manufacturer == '385889803' ) {
            if( column.id == 'total' || column.id == 'vat' ) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }*/
        return true;
      },
      fncActivate(objActive) {
        this.$store.commit('fncActivate', objActive);
      },
      fncDeactivate(objActive) {
        this.$store.commit('fncDeactivate', objActive);
      },
      fncHideModal () {
        this.$store.commit('hideModal');
      },
      fncGenerateColumns() {
        this.$store.commit('fncEmptyQuoteList');
        this.$store.dispatch('fncGenerateColumns');
        this.$store.commit('hideModal');
      },
      fncReorderQuoteColumnsNoSort( obj = [] ) {
        this.$store.dispatch({
          type: 'fncResetColumns',
          noSort: true,
          newSettings: obj
        });
      },
      fncReorderQuoteColumns({ oldIndex, newIndex }) {
        this.$store.dispatch({
          type: 'fncResetColumns',
          start: oldIndex,
          end: newIndex
        });
      },
      fncSaveSettings() {
        this.$store.dispatch({
          type: 'fncResetColumns',
          splice: false
        });
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'quoteList',
        'objQuoteSettings',
        'objQuoteFilters',
        'columnsLoading',
        'columnsSorted',
        'userRoles'
      ])
    },
    created() {
      /*for( var k in this.quoteList ) {
        if( this.objCustomerRegion.indexOf(this.quoteList[k].customer_region) === -1 ) { this.objCustomerRegion.push(this.quoteList[k].customer_region); }
        if( this.objOriginator.indexOf(this.quoteList[k].originator) === -1 ) { this.objOriginator.push(this.quoteList[k].originator); }
        if( this.objStatus.indexOf(this.quoteList[k].status) === -1 ) { this.objStatus.push(this.quoteList[k].status); }
      }
      this.objQuoteSettingsActive = this.objQuoteSettings;
      this.objQuoteSettingsInactive = this.objQuoteSettings;*/
    },
    components: {
      Sortable,
      DatePicker
    },
    beforeMount(){
      this.$store.dispatch('fncPopulateRoles');
    },
    mounted() {

      for( var u in this.userRoles ) {

        if( this.userRoles[u].user_type == '1' ) {
          this.repRoles.push( this.userRoles[u] )
        }

      }

      /*for( var s in this.objQuoteSettings ) {
          if( this.objAuthorize.manufacturer == '385889803' ) {
                if( ( this.objQuoteSettings[s].id != 'total' || this.objQuoteSettings[s].id != 'vat') ) {

                } else {

                }
            } else {

            }
        }*/

      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          dragoverBubble: false,
          onUpdate: this.fncReorderQuoteColumns,
          removeCloneOnHide: false
        }
      )
      if( this.columnsSorted == false ) {
        this.$store.dispatch({
          type: 'fncResetColumns',
          noSort: true
        });
      }
    },
    watch: {
      objQuoteSettings() {
        if (this.objQuoteSettings == undefined || this.objQuoteSettings == null ) {
          this.loaded = false;
        } else {
          this.loaded = true;
        }
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
